export default __webpack_public_path__ + "static/media/Kristin.20dd43f6.png";